import { render } from "./EditorFixedMenu.vue?vue&type=template&id=4a403fde"
import script from "./EditorFixedMenu.vue?vue&type=script&lang=js"
export * from "./EditorFixedMenu.vue?vue&type=script&lang=js"

import "./EditorFixedMenu.vue?vue&type=style&index=0&id=4a403fde&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__